document.addEventListener('DOMContentLoaded', function () {
  // Find the form more reliably
  const form = document.querySelector('form[action*="customer"]') || 
               document.querySelector('#create_customer') ||
               document.querySelector('form');
  
  console.log('Form found:', form);
  console.log('Form action:', form?.action);
  console.log('Form method:', form?.method);
  
  if (!form) {
    console.error('Registration form not found');
    return;
  }

  // Flag to track if validation has passed and form should be submitted
  let isValidationPassed = false;

  const messageError = {
    firstNameEmpty: 'Ingresa tu nombre',
    lastNameEmpty: 'Ingresa tu apellido',
    emailEmpty: 'Ingresa tu correo',
    emailFormat: 'Ingresa un email válido',
    passwordEmpty: 'Ingresa una contraseña',
    passwordFormat: 'La contraseña debe contener un mínimo de 8 caracteres',
  };

  // Remove any existing event listeners and add ours with priority
  const newForm = form.cloneNode(true);
  form.parentNode.replaceChild(newForm, form);

  // Handle form submission with proper validation control and priority
  newForm.addEventListener('submit', function (event) {
    console.log('Form submission attempt detected');
    console.log('isValidationPassed:', isValidationPassed);

    // Stop all other event listeners from executing
    event.stopImmediatePropagation();

    // If validation has already passed, allow normal form submission
    if (isValidationPassed) {
      console.log('Validation already passed, allowing form submission');
      // Don't prevent default, let the form submit naturally
      return true;
    }
    
    // Prevent submission until validation passes
    event.preventDefault();
    
    // Run validation
    const isValid = validateAllFields();
    console.log('Validation result:', isValid);
    
    if (isValid) {
      console.log('Validation passed, submitting form');
      // Set flag to allow submission and trigger submit again
      isValidationPassed = true;
      // Use a slight delay to ensure the flag is set before triggering submit
      setTimeout(() => {
        newForm.submit();
      }, 10);
    } else {
      console.log('Validation failed, form will not submit');
    }
  }, true); // Use capture phase to execute before other listeners

  function validateAllFields() {
    // Remove the hardcoded return false
    const firstNameField = document.querySelector("#RegisterForm-FirstName");
    const lastNameField = document.querySelector("#RegisterForm-LastName");
    const emailField = document.querySelector('#RegisterForm-email');
    const passwordField = document.querySelector('#RegisterForm-password');

    // Check if all fields exist
    if (!firstNameField || !lastNameField || !emailField || !passwordField) {
      console.error('One or more form fields not found');
      console.log('FirstName:', firstNameField);
      console.log('LastName:', lastNameField);
      console.log('Email:', emailField);
      console.log('Password:', passwordField);
      return false;
    }

    // Get or create error elements
    const firstNameError = getOrCreateErrorElement('RegisterForm-first-name-error', firstNameField);
    const lastNameError = getOrCreateErrorElement('RegisterForm-last-name-error', lastNameField);
    const emailError = getOrCreateErrorElement('RegisterForm-email-error', emailField);
    const passwordError = getOrCreateErrorElement('RegisterForm-password-error', passwordField);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let validationResults = {
      firstNameValidate: false,
      lastNameValidate: false,
      emailValidate: false,
      passwordValidate: false,
    };

    // Validate first name
    if (firstNameField.value.trim() === '') {
      showError(firstNameField, firstNameError, messageError.firstNameEmpty);
      validationResults.firstNameValidate = false;
    } else {
      hideError(firstNameField, firstNameError);
      validationResults.firstNameValidate = true;
    }

    // Validate last name
    if (lastNameField.value.trim() === '') {
      showError(lastNameField, lastNameError, messageError.lastNameEmpty);
      validationResults.lastNameValidate = false;
    } else {
      hideError(lastNameField, lastNameError);
      validationResults.lastNameValidate = true;
    }

    // Validate email
    if (emailField.value.trim() === '') {
      showError(emailField, emailError, messageError.emailEmpty);
      validationResults.emailValidate = false;
    } else if (!emailRegex.test(emailField.value.trim())) {
      showError(emailField, emailError, messageError.emailFormat);
      validationResults.emailValidate = false;
    } else {
      hideError(emailField, emailError);
      validationResults.emailValidate = true;
    }

    // Validate password
    if (passwordField.value === '') {
      showError(passwordField, passwordError, messageError.passwordEmpty);
      validationResults.passwordValidate = false;
    } else if (passwordField.value.length < 8) {
      showError(passwordField, passwordError, messageError.passwordFormat);
      validationResults.passwordValidate = false;
    } else {
      hideError(passwordField, passwordError);
      validationResults.passwordValidate = true;
    }

    // Return true only if ALL validations pass
    const allFieldsValid = Object.values(validationResults).every(value => value === true);
    
    console.log('Validation results:', validationResults);
    console.log('All fields valid:', allFieldsValid);
    
    return allFieldsValid;
  }

  // Real-time validation setup with null checks
  const emailField = document.querySelector('#RegisterForm-email');
  const firstNameField = document.querySelector('#RegisterForm-FirstName');
  const lastNameField = document.querySelector('#RegisterForm-LastName');
  const passwordField = document.querySelector('#RegisterForm-password');
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Email real-time validation
  if (emailField) {
    emailField.addEventListener('input', function (event) {
      const emailError = document.querySelector("#RegisterForm-email-error");
      const inputValue = event.target.value.trim();
      if (inputValue !== '' && emailRegex.test(inputValue) && emailError) {
        hideError(emailField, emailError);
      }
    });

    emailField.addEventListener('blur', function (event) {
      const emailError = getOrCreateErrorElement('RegisterForm-email-error', emailField);
      const inputValue = event.target.value.trim();
      if (inputValue !== '' && emailRegex.test(inputValue)) {
        hideError(emailField, emailError);
      } else if (inputValue !== '' && !emailRegex.test(inputValue)) {
        showError(emailField, emailError, messageError.emailFormat);
      } else if (inputValue === '') {
        showError(emailField, emailError, messageError.emailEmpty);
      }
    });
  }

  // First name real-time validation
  if (firstNameField) {
    firstNameField.addEventListener('input', function (event) {
      const firstNameError = document.querySelector("#RegisterForm-first-name-error");
      const inputValue = event.target.value.trim();
      if (inputValue !== '' && firstNameError) {
        hideError(firstNameField, firstNameError);
      }
    });

    firstNameField.addEventListener('blur', function (event) {
      const firstNameError = getOrCreateErrorElement('RegisterForm-first-name-error', firstNameField);
      const inputValue = event.target.value.trim();
      if (inputValue === '') {
        showError(firstNameField, firstNameError, messageError.firstNameEmpty);
      } else {
        hideError(firstNameField, firstNameError);
      }
    });
  }

  // Last name real-time validation
  if (lastNameField) {
    lastNameField.addEventListener('input', function (event) {
      const lastNameError = document.querySelector("#RegisterForm-last-name-error");
      const inputValue = event.target.value.trim();
      if (inputValue !== '' && lastNameError) {
        hideError(lastNameField, lastNameError);
      }
    });

    lastNameField.addEventListener('blur', function (event) {
      const lastNameError = getOrCreateErrorElement('RegisterForm-last-name-error', lastNameField);
      const inputValue = event.target.value.trim();
      if (inputValue === '') {
        showError(lastNameField, lastNameError, messageError.lastNameEmpty);
      } else {
        hideError(lastNameField, lastNameError);
      }
    });
  }

  // Password real-time validation
  if (passwordField) {
    passwordField.addEventListener('input', function (event) {
      const passwordError = getOrCreateErrorElement('RegisterForm-password-error', passwordField);
      const inputValue = event.target.value;

      if (inputValue === '') {
        showError(passwordField, passwordError, messageError.passwordEmpty);
      } else if (inputValue.length < 8) {
        showError(passwordField, passwordError, messageError.passwordFormat);
      } else {
        hideError(passwordField, passwordError);
      }
    });

    passwordField.addEventListener('blur', function (event) {
      const passwordError = getOrCreateErrorElement('RegisterForm-password-error', passwordField);
      const inputValue = event.target.value;

      if (inputValue === '') {
        showError(passwordField, passwordError, messageError.passwordEmpty);
      } else if (inputValue.length < 8) {
        showError(passwordField, passwordError, messageError.passwordFormat);
      }
    });
  }

  // Helper functions
  function getOrCreateErrorElement(errorId, field) {
    let errorElement = document.querySelector(`#${errorId}`);
    if (!errorElement) {
      errorElement = document.createElement('span');
      errorElement.id = errorId;
      errorElement.className = 'form__message';
      errorElement.style.cssText = `
        display: none;
        color: #CA1722;
        font-size: 14px;
        margin-top: 5px;
        font-weight: 400;
        line-height: 1.2;
      `;
      
      // Insert after the field element instead of appending to parent
      if (field.nextSibling) {
        field.parentNode.insertBefore(errorElement, field.nextSibling);
      } else {
        field.parentNode.appendChild(errorElement);
      }
    }
    return errorElement;
  }

  function showError(field, errorField, errorMessage) {
    if (errorField) {
      errorField.textContent = errorMessage;
      errorField.style.display = 'block';
      field.style.borderColor = "#CA1722";
      console.log('Showing error:', errorMessage); // Debug log
    }
  }

  function hideError(field, errorField) {
    if (errorField) {
      errorField.textContent = '';
      errorField.style.display = 'none';
      field.style.borderColor = '#9C9C9C';
    }
  }
});